import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';

@Component({
  selector: 'app-ip-value',
  standalone:false,
  templateUrl: './ip-value.component.html',
  styleUrl: './ip-value.component.scss'
})
export class IpValueComponent implements OnInit {
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() screening: string = '';
    @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  challengeForm: FormGroup;
  proposalForm: FormGroup;
  uploadedFiles: any[] = [];
  apiUrl = environment.APIUrl;
  payload: any;
  @Input() id: any;
  PDSGenId: any;
  needGenData: any;
  needGenId;
  draftSotr: File;
  draftSotrFile: File | null = null;
  supportingDocsFiles: File | null = null;
  private subscriptions = new Subscription();
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  userID: any;
  unitList: any;
  userList: any;
  userListCopy: any;
  selectedDraftProposal: any;
  initReadonly = {
  ...this.init,
  toolbar: false,
  readonly: true
};
  categoryOptions = [
  { label: 'To Move', value: 'To Move' },
  { label: 'To Fight', value: 'To Fight' },
  { label: 'To Float', value: 'To Float' }
];
    priorityOptions = [
    { label: 'High', value: 'High' },
    { label: 'Medium', value: 'Medium' },
    { label: 'Low', value: 'Low' },
  ];
  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }
  ngOnInit(): void {
    this.challengeForm = this.fb.group({
      organisation: ['', Validators.required],
      category: [''],
      release_date: ['', Validators.required],
      approved_by: [''],
      coordinated_agency: [null, Validators.required],
      technology_domain: ['', Validators.required],
      valuation: ['', Validators.required],

      challenge_title: ['', Validators.required],
      nodal_officer: [null, Validators.required],
      problem_statement: ['', Validators.required],
      challenge_brief: ['', Validators.required],
      prototype_development: ['', Validators.required],
      requirement: [''],
      ipValue: [''],
      functional_advantages: [''],
      domestic: [''],
      substitution: [''],
      preliminary_scope: [''],
      competitive_solution: [''],
      potential_market: [''],
      risk_assessment: [''],
      mpo_qty: [''],
    });

    this.proposalForm = this.fb.group({
      technologyInsertion: [''],
      justificationText: [''],
      exportPotential: [''],
      objective: [''],
      existingSystem: [''],
      functionalRequirements: [''],
      contemporarySolutions: [''],
      miscellaneousInfo: [''],
      references: [''],
      keywords: [''],
      estimatedRequirement: [''],
      testingMethodology: [''],
      civilSpinOffs: [''],
      technologyReadinessLevel: [''],
      proposalExplanation: [''],
      qaAgency: [''],
      apsoConcurrence: [''],
    });

    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
      
      // Load unit and user lists first, then get challenge approval data
      // This is inside subscribe to ensure payload is initialized
      this.getUnit();
      this.getUserList();
      // Use setTimeout to ensure lists are loaded before patching form
      setTimeout(() => {
        this.getChallengeApprovalData();
      }, 300);
    });
    
    this.getChallenge();
  }
  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
  {
    challengeForm: false,
    basicInfo: true,
    equipment: false,
    quantity: false,
    cost: false,
    detailedInfo: false,
    uploads: false,
    vendorTable: false,
    nodal: false,
    problem: false,
    detailedInformation: false,
    uploadChallengeDocs: false,
  };
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if ( this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.challengeForm?.enable();
        this.proposalForm?.enable();
      } else {
        this.isEditorDisabled = true;
        this.challengeForm?.disable();
        this.proposalForm?.disable();
      }
      //  this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      plugins:
        'advlist anchor fullscreen insertdatetime autolink link lists image code advcode mergetags wordcount ai a11ychecker advcode advtemplate advlist advtable anchor autocorrect autosave editimage image link linkchecker lists markdown media mediaembed pageembed powerpaste searchreplace table template tinymcespellchecker typography visualblocks wordcount',
      toolbar:
        'undo redo fullscreen | styles fontsizeinput lineheight |insertdatetime  bold italic strikethrough backcolor forecolor visualblocks | align bullist numlist outdent indent | advlist  table link image media pageembed | spellcheckdialog a11ycheck code | searchreplace',
      readonly: this.isEditorDisabled,
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }

  onFileSelect(event: any, type: string) {
    const files: File[] = event.files;

    if (type === 'draftSotr') {
      this.draftSotrFile = files[0]; // Only one file expected
    } else if (type === 'supportingDocs') {
      // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
      this.supportingDocsFiles = files[0];
    }
  }
  //collapsible section 
   isSectionOpen = {
    requirement: true,
    system: false,
    additional: false,
    testing: false,
    proposal: false,
    uploads: false,
    description: false,
    functionalRequirements: false,
      basicInfo: true,
    equipment: true,
    quantity: true,
    cost: true,
    detailed: true,
    
  };

  onUploadDraftSotr(event: any) {
    const file: File = event.files[0];
    if (file) {
      this.draftSotrFile = file;
      this.messageService.add({
        severity: 'success',
        summary: 'File attached successfully',
        detail: file.name,
      });
    }
  }
 getUnit() {
    const sub = this.apiService
      .getAPI('/master/units/')
      .subscribe((res: any) => {
        this.unitList = res.data;
      });
    this.subscriptions.add(sub);
  }

    onUnitChange(event: any) {
    let unit_id = event.value;
    this.userList = this.userListCopy.filter(
      (user) => user.unit?.id == unit_id
    );
  }

    getUserList() {
    const sub = this.apiService
      .getAPI('/account/users/')
      .subscribe((res: any) => {
        this.userList = res.data;
        this.userListCopy = [...this.userList];
      });
    this.subscriptions.add(sub);
  }

    onUserChange(event: any) {
    this.userID = event.value;
  }


  
  onUploadSupportingDocs(event: any) {
    // const files: File[] = event.files;
    const file: File = event.files[0];
    if (file) {
      this.supportingDocsFiles = file;
    }
    // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
    this.messageService.add({
      severity: 'success',
      summary: 'Supporting Documents Uploaded',
      detail: ` files uploaded`,
    });
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  generatePDF() {
    let payload;

      payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: 'Proposal Name', value: this.payload.proposal_name },
           {
            key: 'Valuation',
            value: this.challengeForm.get('valuation')?.value,
          },
          {
            key: 'IP Value',
            value: this.challengeForm.get('ipValue')?.value,
          },
        ],
      };
    

    this.generatePDFEmitter.emit(payload);
  }
  onSubmit() {
      let formData: FormData = new FormData();

      formData.append('ProposalStep', this.id);
      // formData.append('organisation',this.challengeForm.get('organisation').value);
      // formData.append('category', this.challengeForm.get('category').value);
      // formData.append('release_date',this.challengeForm.get('releaseDate').value);
      // if(this.challengeForm.get('approvedBy').value !=null){
      //   formData.append('approved_by',this.challengeForm.get('approvedBy').value);
      // }
      // formData.append('coordinated_agency',this.challengeForm.get('coordinatingAgency').value);
      // formData.append('technology_domain',this.challengeForm.get('technologyDomain').value);
      formData.append('ip_status',this.challengeForm.get('valuation').value);
      

      // formData.append('title', this.challengeForm.get('challengeTitle').value);
      // formData.append('nodal_officer',this.challengeForm.get('nodalOfficer').value);
      // formData.append('problem_statement', this.challengeForm.get('problemStatement').value);
      // formData.append('challenge_brief',this.challengeForm.get('challengeBrief').value);
      // formData.append('prototype_development',this.challengeForm.get('prototypeDevelopment').value);
      // formData.append('requirement',this.challengeForm.get('requirement').value);
      formData.append('ip_value', this.challengeForm.get('ipValue').value);
      // formData.append('functional_advantages',this.challengeForm.get('functionalAdvantages').value);
      // formData.append('domestic', this.challengeForm.get('domestic').value);
      // formData.append('substitution',this.challengeForm.get('substitution').value);
      // formData.append('preliminary_scope',this.challengeForm.get('preliminaryScope').value);
      // formData.append('competitive_solution',this.challengeForm.get('competitiveSolution').value);
      // formData.append('potential_market',this.challengeForm.get('potentialMarket').value);
      // formData.append('risk_assessment',this.challengeForm.get('riskAssessment').value);
      // formData.append('mpo_qty', this.challengeForm.get('mpoQty').value);

      //    if (this.draftSotrFile) {
      //   formData.append('pds', this.draftSotrFile);
      // }

      // if (this.supportingDocsFiles) {
      //   // this.supportingDocsFiles.forEach(file => {
      //   formData.append('pru', this.supportingDocsFiles); // Change key name if needed
      //   // });
      // }

      if (this.PDSGenId) {
        const sub = this.apiService
          .putAPI(`/idex/ip/valuation/${this.PDSGenId}/`, formData)
          .subscribe({
            next: (res: any) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Valuation updated successfully.',
              });
            this.fileUpload.clear();
            this.draftSotrUpload.clear();
              this.getChallenge();
            },
            error: (err) => {},
          });
        this.subscriptions.add(sub);
      } else {
        const sub = this.apiService
          .postAPI(`/idex/ip/valuation/`, formData)
          .subscribe({
            next: (res: any) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Valuation added successfully.',
              });
              this.getChallenge();
            },
            error: (err) => {},
          });
        this.subscriptions.add(sub);
      }
    
  }

  getChallenge() {
    if (!this.payload || !this.payload.proposal_id || !this.id) {
      console.warn('Payload or id not initialized yet, skipping getChallenge call', {
        payload: this.payload,
        id: this.id
      });
      return;
    }

    const sub = this.apiService
      .getAPI(
        `/idex/ip/valuation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
      )
      .subscribe((resp: any) => {
        let res = resp.challenge;
        if (res) {
          this.needGenData = resp.challenge;
          
          // Handle coordinated_agency - it might be an ID or an object
          let coordinatedAgencyValue = null;
          if (res.coordinated_agency) {
            if (typeof res.coordinated_agency === 'number' || typeof res.coordinated_agency === 'string') {
              coordinatedAgencyValue = Number(res.coordinated_agency);
            } else if (res.coordinated_agency?.id) {
              coordinatedAgencyValue = res.coordinated_agency.id;
            } else if (res.coordinated_agency_id) {
              coordinatedAgencyValue = res.coordinated_agency_id;
            }
          }
          
          // Handle nodal_officer - it might be an ID or an object
          let nodalOfficerValue = null;
          if (res.nodal_officer) {
            if (typeof res.nodal_officer === 'number' || typeof res.nodal_officer === 'string') {
              nodalOfficerValue = Number(res.nodal_officer);
            } else if (res.nodal_officer?.id) {
              nodalOfficerValue = res.nodal_officer.id;
            } else if (res.nodal_officer_id) {
              nodalOfficerValue = res.nodal_officer_id;
            }
          }
          
          // Format release_date if it exists
          let releaseDateValue = res?.release_date;
          if (releaseDateValue && releaseDateValue.includes('T')) {
            releaseDateValue = releaseDateValue.split('T')[0];
          }
          
          this.challengeForm.patchValue({
            organisation: res?.organisation || '',
            category: res?.category || '',
            release_date: releaseDateValue || '',
            approved_by: res?.approved_by || '',
            coordinated_agency: coordinatedAgencyValue,
            technology_domain: res?.technology_domain || '',
            valuation: res?.ip_status || '',
            challenge_title: res?.title || '',
            nodal_officer: nodalOfficerValue,
            problem_statement: res?.problem_statement || '',
            challenge_brief: res?.challenge_brief || '',
            prototype_development: res?.prototype_development || '',
            requirement: res?.requirement || '',
            ipValue: res?.ip_value || '',
            functional_advantages: res?.functional_advantages || '',
            domestic: res?.domestic || '',
            substitution: res?.substitution || '',
            preliminary_scope: res?.preliminary_scope || '',
            competitive_solution: res?.competitive_solution || '',
            potential_market: res?.potential_market || '',
            risk_assessment: res?.risk_assessment || '',
            mpo_qty: res?.mpo_qty || '',
          });
          
        }
        if (res && res.status) {
          this.PDSGenId = res?.id;
        }
      });
    this.subscriptions.add(sub);
  }


   getChallengeApprovalData() {
    if (!this.payload || !this.payload.proposal_id || !this.id) {
      console.warn('Payload or id not initialized yet, skipping getChallengeApprovalData call', {
        payload: this.payload,
        id: this.id
      });
      return;
    }

    let url;
    if (this.screening == 'formulation') {
      url = `/idex/challenges/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else if (this.screening == 'initiation') {
      url = `/idex/screening/challenge/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else {
      url = `/idex/challenge/approval/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    }
    
    const sub = this.apiService.getAPI(url).subscribe((resp: any) => {
      let res = resp[0] || resp.challenge;
      if (res) {
        this.needGenData = resp[0] || resp.challenge;
        // Set selectedDraftProposal to include dms_files for document upload component
        this.selectedDraftProposal = res;
        
        // Handle coordinated_agency - it might be an ID or an object
        let coordinatedAgencyValue = null;
        if (res.coordinated_agency) {
          if (typeof res.coordinated_agency === 'number' || typeof res.coordinated_agency === 'string') {
            coordinatedAgencyValue = Number(res.coordinated_agency);
          } else if (res.coordinated_agency?.id) {
            coordinatedAgencyValue = res.coordinated_agency.id;
          } else if (res.coordinated_agency_id) {
            coordinatedAgencyValue = res.coordinated_agency_id;
          }
        }
        
        // Handle nodal_officer - it might be an ID or an object
        let nodalOfficerValue = null;
        if (res.nodal_officer) {
          if (typeof res.nodal_officer === 'number' || typeof res.nodal_officer === 'string') {
            nodalOfficerValue = Number(res.nodal_officer);
          } else if (res.nodal_officer?.id) {
            nodalOfficerValue = res.nodal_officer.id;
          } else if (res.nodal_officer_id) {
            nodalOfficerValue = res.nodal_officer_id;
          }
        }
        
        // Format release_date if it exists
        let releaseDateValue = res?.release_date;
        if (releaseDateValue && releaseDateValue.includes('T')) {
          releaseDateValue = releaseDateValue.split('T')[0];
        }
        
        // Patch the form with all the data from idex component
        this.challengeForm.patchValue({
          organisation: res?.organisation || '',
          category: res?.category || '',
          release_date: releaseDateValue || '',
          approved_by: res?.approved_by || '',
          coordinated_agency: coordinatedAgencyValue,
          technology_domain: res?.technology_domain || '',
          challenge_title: res?.title || '',
          nodal_officer: nodalOfficerValue,
          problem_statement: res?.problem_statement || '',
          challenge_brief: res?.challenge_brief || '',
          prototype_development: res?.prototype_development || '',
          requirement: res?.requirement || '',
          functional_advantages: res?.functional_advantages || '',
          domestic: res?.domestic || '',
          substitution: res?.substitution || '',
          preliminary_scope: res?.preliminary_scope || '',
          competitive_solution: res?.competitive_solution || '',
          potential_market: res?.potential_market || '',
          risk_assessment: res?.risk_assessment || '',
          mpo_qty: res?.mpo_qty || '',
        });
      }
      if (res && res.status) {
        this.PDSGenId = res?.id;
      }
    });
    this.subscriptions.add(sub);
  }

}


